export default __webpack_public_path__ + "static/media/dc-02.59b4f9c5.jpg";